<p-toast></p-toast>
<div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
        <div class="col-12 mt-5 xl:mt-0 text-center">
            <!-- <img src="assets/micada_logo.png" alt="Sakai logo" class="mb-5" style="width:100px; height:70px;"> -->
        </div>

        <div class="col-12 xl:col-6"
            style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="h-full w-full m-0 py-3 px-4"
                style="border-radius:53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0));">
                <div class="text-center mb-5">
                    <img src="assets/micada_logo.png" alt="Image" height="70" class="mb-3">

                    <div class="text-900 text-3xl font-medium mb-3">{{'WELCOME'| translate}}</div>
                    <span class="text-600 font-medium">{{'RESET_YOUR_PASSWORD_HERE'| translate}}</span>
                </div>
                <form [formGroup]="onAuthForm">
                    <div class="w-full md:w-10 mx-auto">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">{{'EMAIL/USERNAME'| translate}}</label>
                        <input id="email1" type="text" formControlName="email" placeholder="{{'EMAIL'| translate}}" pInputText
                            class="w-full mb-3" style="padding:1rem;" [readonly]="disableUserName">


                        <div style="display: flex; justify-content: flex-end">
                            <div *ngIf="display != null && display != '00:00'">
                                {{'YOU_CAN_REQUEST_OTP_IN'| translate}} {{display}} {{'MINUTES'| translate}}
                            </div>
                            <button pButton pRipple label="{{'GET_OTP'| translate}}" *ngIf="display == null || display == '00:00'"
                                class="p-button-outlined p-button-secondary mr-2 mb-2" (click)="onOTPClick()"></button>
                        </div>

                        <div *ngIf="showPasswordsSections">

                            <label for="otp" class="block text-900 font-medium text-xl mb-2">{{'ENTER_OTP'| translate}}</label>
                            <input id="otp" type="text" placeholder="{{'OTP'| translate}}" pInputText class="w-full mb-3"
                                style="padding:1rem;" formControlName="otp"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.otp.errors }">
                            <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                <div *ngIf="f.otp.errors.required">{{'OTP_IS_REQ'| translate}}</div>
                            </div>
                            <label for="password1" class="block text-900 font-medium text-xl mb-2 mt-2">{{'NEW_PASSWORD'| translate}}</label>
                            <p-password id="password1" formControlName="password" placeholder="{{'PASSWORD'| translate}}"
                                [toggleMask]="false" [feedback]="false" styleClass="w-full mb-3" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.password.errors }"></p-password>
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">{{'PASSWORD_IS_REQ'| translate}}</div>
                            </div>
                            <label for="password1" class="block text-900 font-medium text-xl mb-2 mt-2">{{'RE_ENTER_PASSWORD'| translate}}</label>
                            <p-password id="reEnteredPassword" formControlName="reEnteredPassword"
                                placeholder="{{'RE_ENTER_PASSWORD'| translate}}" [toggleMask]="true" [feedback]="false"
                                styleClass="w-full mb-3" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.reEnteredPassword.errors }"></p-password>
                            <div *ngIf="submitted && f.reEnteredPassword.errors" class="invalid-feedback">
                                <div *ngIf="f.reEnteredPassword.errors.required">{{'RE_ENTER_PASSWORD_IS_REQ'| translate}}</div>
                            </div>

                            <button pButton pRipple label="{{'CHANGE_PASSWORD'| translate}}" class="w-full p-3 text-xl mt-3"
                                (click)="changePassword()"></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>